module.exports = __webpack_public_path__ + "img/train-icon.f16bca6c.png";